import ReportProductList from '_modules/reports/views/ReportProductList.vue';
import ReportUserList from '_modules/reports/views/ReportUserList.vue';
import ReportTagsList from '_modules/reports/views/ReportTagsList.vue';
import Reports from './Root.vue';

export default {
  path: 'relatorios/',
  component: Reports,
  name: 'admin-report',
  redirect: '/relatorios/produtos',
  children: [
    {
      path: 'produtos/:page',
      name: 'admin-report-product',
      component: ReportProductList,
    },
    {
      path: 'usuarios/:page',
      name: 'admin-report-user',
      component: ReportUserList,
    },
    {
      path: 'tags/:page',
      name: 'admin-report-tags',
      component: ReportTagsList,
    },
  ],
};
